import { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/work", label: "Work" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
];

const mobileLinks = [
  { to: "/work", label: "Work" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/process", label: "Process" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/contact", label: "Contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-[2px]"
      style={{ backgroundColor: "rgba(245, 240, 232, 0.92)", borderBottom: "0.5px solid rgba(26,26,26,0.35)" }}
      data-testid="site-header"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14">
        <div className="flex items-center justify-between py-5 md:py-6">
          <Link
            to="/"
            className="font-serif text-xl md:text-2xl tracking-tight leading-none flex items-baseline gap-2"
            data-testid="logo-link"
          >
            <span className="serif-display">Shivani</span>
            <span className="text-[0.65rem] tracking-[0.22em] uppercase font-sans" style={{ color: "rgba(26,26,26,0.55)" }}>
              Brand Strategy
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8 lg:gap-10">
            <nav className="flex items-center gap-8 lg:gap-12" data-testid="primary-nav">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  data-testid={`nav-${l.label.toLowerCase()}`}
                  className={({ isActive }) =>
                    `text-[0.78rem] tracking-[0.16em] uppercase font-sans transition-opacity ${
                      isActive ? "opacity-100" : "opacity-65 hover:opacity-100"
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
            </nav>

            <span
              className="inline-flex items-center gap-2 px-3 py-1.5 eyebrow whitespace-nowrap"
              style={{ border: "0.5px solid rgba(26,26,26,0.35)" }}
              data-testid="nav-booking-status"
            >
              <span className="booking-status-dot" aria-hidden />
              Booking Q2 2026
            </span>

            <Link
              to="/contact"
              className="inline-block text-[0.75rem] tracking-[0.18em] uppercase font-sans px-5 py-2.5 transition-colors hover:bg-[#1A1A1A] hover:text-[#F5F0E8]"
              style={{ border: "0.5px solid #1A1A1A" }}
              data-testid="nav-cta-start-project"
            >
              Start a Project
            </Link>
          </div>

          <button
            onClick={() => setOpen((v) => !v)}
            className="md:hidden p-2 -mr-2"
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={22} strokeWidth={1.25} /> : <Menu size={22} strokeWidth={1.25} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          className="md:hidden"
          style={{ backgroundColor: "#F5F0E8", borderTop: "0.5px solid rgba(26,26,26,0.35)" }}
          data-testid="mobile-menu"
        >
          <nav className="px-6 py-6 flex flex-col gap-5">
            {mobileLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `font-serif text-3xl tracking-tight ${isActive ? "" : "opacity-60"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              className="mt-2 inline-block w-fit text-[0.75rem] tracking-[0.18em] uppercase font-sans px-5 py-3"
              style={{ border: "0.5px solid #1A1A1A" }}
              data-testid="mobile-cta-start-project"
            >
              Start a Project →
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
